// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3AWc6","modalFooterButton":"ModalNotes_modalFooterButton__1CEJ4"};